import { Controller } from "@hotwired/stimulus"
import {
  hasTekInSession,
  unwrapMessageKeyWithTek,
  decryptFileWithMessageKey
} from "../crypto"

// Handles downloading and decrypting outbox E2E encrypted files for the sender.
// Uses the encrypted_message_key stored on the outgoing message, unwraps it
// with the TEK private key, then decrypts individual files with the message key.
export default class extends Controller {
  static values = {
    downloadUrl: String,
    encryptedMessageKey: String,
    iv: String,
    filename: String,
    contentType: String
  }

  async download(event) {
    event.preventDefault()

    if (!(await hasTekInSession())) {
      alert("Sleutels niet beschikbaar. Log opnieuw in.")
      return
    }

    try {
      // Unwrap the message key using TEK private key
      const messageKey = await unwrapMessageKeyWithTek(
        this.encryptedMessageKeyValue
      )

      // Fetch the encrypted file via the download endpoint
      const response = await fetch(this.downloadUrlValue)
      if (!response.ok) {
        throw new Error("Bestand ophalen mislukt.")
      }

      const ciphertext = await response.arrayBuffer()

      // Decrypt with the message key
      const plaintext = await decryptFileWithMessageKey(
        messageKey,
        this.ivValue,
        ciphertext
      )

      // Trigger browser download
      const blob = new Blob([plaintext], { type: this.contentTypeValue || "application/octet-stream" })
      const url = URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = url
      link.download = this.filenameValue
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    } catch (error) {
      console.error("Decryption failed:", error)
      alert("Ontsleuteling mislukt. Controleer of je ingelogd bent.")
    }
  }
}
